import * as React from 'react';

const SvgCall = (props) => (
  <svg
    width={12}
    height={12}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.985 9.165c0 .18-.04.365-.125.545-.085.18-.195.35-.34.51-.245.27-.515.465-.82.59-.3.125-.625.19-.975.19-.51 0-1.055-.12-1.63-.365a8.782 8.782 0 0 1-1.72-.99c-.575-.42-1.12-.885-1.64-1.4-.515-.52-.98-1.065-1.395-1.635-.41-.57-.74-1.14-.98-1.705C1.12 4.335 1 3.79 1 3.27c0-.34.06-.665.18-.965.12-.305.31-.585.575-.835.32-.315.67-.47 1.04-.47.14 0 .28.03.405.09.13.06.245.15.335.28l1.16 1.635c.09.125.155.24.2.35a.79.79 0 0 1 .07.305c0 .12-.035.24-.105.355a1.7 1.7 0 0 1-.28.355l-.38.395a.268.268 0 0 0-.08.2c0 .04.005.075.015.115.015.04.03.07.04.1.09.165.245.38.465.64.225.26.465.525.725.79.27.265.53.51.795.735.26.22.475.37.645.46.025.01.055.025.09.04.04.015.08.02.125.02.085 0 .15-.03.205-.085l.38-.375c.125-.125.245-.22.36-.28a.666.666 0 0 1 .355-.105c.095 0 .195.02.305.065.11.045.225.11.35.195l1.655 1.175c.13.09.22.195.275.32.05.125.08.25.08.39Z'
      fill='#4CB158'
    />
  </svg>
);

export default SvgCall;
